export type SvidQuery = {
    isPresent: boolean
    value: string
}

export const STELE_DEVICE_ATTRIBUTE = 'data-stele'

export function parseSvidQuery(search: string): SvidQuery {
    const params = new URLSearchParams(
        search.startsWith('?') ? search.slice(1) : search,
    )
    if (!params.has('SVID')) {
        return { isPresent: false, value: '' }
    }
    return { isPresent: true, value: params.get('SVID') ?? '' }
}

export function getResolvedSvid(query: SvidQuery): string | null {
    if (!query.isPresent) {
        return null
    }
    const trimmed = query.value.trim()
    return trimmed.length > 0 ? trimmed : null
}

// reflect stele device flag to html for overriding viewport query
export function applySteleDeviceAttribute(isStele: boolean): void {
    if (typeof document === 'undefined') {
        return
    }
    const root = document.documentElement
    if (isStele) {
        root.setAttribute(STELE_DEVICE_ATTRIBUTE, 'true')
    } else {
        root.removeAttribute(STELE_DEVICE_ATTRIBUTE)
    }
}
